import React from "react";
import { Divider } from "@material-ui/core";
import styled from "styled-components";

const StyledDiv = styled.div`  
  font-weight: normal;
  font-style: normal;
  padding-top: 20px;
  margin-bottom: 20px;
  font-size:20px;
`;

class SectionTitle extends React.Component {
  render() {
    const { children } = this.props;

    return (
      <StyledDiv>
        {children}
        <Divider />
      </StyledDiv>
    );
  }
}
export default SectionTitle;
